import { translate } from '../../../helpers/translations/translator'

export const getDeclineToastMessage = (hasPendingChangeset: boolean): string => (
    hasPendingChangeset
        ? translate('pages.absences.refuseChangeRequest')
        : translate('pages.absences.refuseLOARequest')
)

export const getApproveToastMessage = (hasPendingChangeset: boolean): string => (
    hasPendingChangeset
        ? translate('pages.absences.acceptChangeRequest')
        : translate('pages.absences.acceptLOARequest')
)
